import { PureComponent } from 'react';

import Field from 'Component/Field';
import FIELD_TYPE from 'Component/Field/Field.config';
import Image from 'Component/Image';
import Link from 'Component/Link';
import { formatPrice } from 'Util/Price';

import './ProductRelatedAccessoriesCard.style';

/** @namespace Pwa/Component/ProductRelatedAccessoriesCard/Component */
export class ProductRelatedAccessoriesCard extends PureComponent {
    renderCheckBox() {
        const { addAccessoriesToList } = this.props;

        return (
            <Field
                attr={{
                    id: 'related_accessories',
                }}
                type={FIELD_TYPE.checkbox}
                events={{
                    onChange: addAccessoriesToList,
                }}
                isChecked
            />
        );
    }

    renderContent() {
        const {
            product: {
                small_image,
                name,
                url: productUrl,
                price_range: {
                    minimum_price: {
                        final_price: { currency, value: finalValue },
                        discount: { amount_off },
                        regular_price: { value: regularValue },
                    },
                },
                stock_item: { in_stock },
            },
        } = this.props;

        if (!in_stock) return null;

        return (
            <div block="ProductRelated" elem="ProductList">
                <div block="ProductRelated" elem="Checkbox">
                    {this.renderCheckBox()}
                </div>
                <Link block="ProductRelated" elem="ImageContainer" to={productUrl}>
                    <Image block="ProductRelated" elem="Image" ratio="square" src={small_image?.url} />
                </Link>
                <Link block="ProductRelated" elem="Details" to={productUrl}>
                    <p block="ProductRelated" elem="Name">
                        {name}
                    </p>
                    <div block="ProductRelated" elem="Price">
                        {amount_off === 0 && (
                            <p block="ProductRelated" elem="RegularPrice">
                                {formatPrice(regularValue, currency)}
                            </p>
                        )}
                        {amount_off > 0 && (
                            <>
                                <p block="ProductRelated" elem="FinalPrice">
                                    {formatPrice(finalValue, currency)}
                                </p>
                                <p block="ProductRelated" elem="DiscountPrice">
                                    {formatPrice(regularValue, currency)}
                                </p>
                            </>
                        )}
                    </div>
                </Link>
            </div>
        );
    }

    render() {
        return this.renderContent();
    }
}

export default ProductRelatedAccessoriesCard;
